import _v from './vars';
import _u from './util';
import _feed from './templates/feed_t';
import getFeed from './feed';
import _ from 'lodash';

/* INFINITE SCROLL LOGIC */
let scrollPos = 0;

function infScroll(e) {
	if (window.pageYOffset < scrollPos) {
		return;
	}

	// saves the new position for iteration.
	scrollPos = window.pageYOffset;
	if (_v.processing) return false

	if ((document.querySelector('.feed-container').getBoundingClientRect().height + document.querySelector('.feed-container').getBoundingClientRect().top) < window.innerHeight * 1.25) {
		_v.processing = true;
		// For REC engine API CALL
		if (!_v.noMoreRecEngineFeedContent) {
			loadNewFeed();
		}
	}
}

function loadNewFeed() {
	for (let i = 0; i <= 10; i++) {
		document.querySelector('.feed-container').appendChild(_u.strToDom(_feed.feedLoader()));
	}
	getFeed();
}

window.addEventListener('scroll', infScroll);
/* / INFINITE SCROLL LOGIC */


/* FEED REFRESH LOGIC */
let newDataisPresentTimer;

function compare(arr1, arr2) {
    if (!arr1 || !arr2) return

    let result = false;
    arr1.forEach(e => {
        let r = _.filter(arr2, { contentId: e.contentId });
        if (_.isEmpty(r)) {
            result = true;
        }
    });
    return result;
}

function checkIfNewDataIsPresent() {
    newDataisPresentTimer = setTimeout(function () {
		let queryParams = 'page=1&limit=1';
		if (_v.topContId || _v.topArticleId) {
			queryParams = (_v.topContId ? 'aspen_feed_nid=' + _v.topContId: 'article_id='+_v.topArticleId)+'&'+queryParams;
		}
		_u.apiGet(_v.contentFeedURL+queryParams, true).then(feed => {
            if (feed) {
                if (feed.data.length > 0) {
                    if (compare(feed.data, _v.firstPageFeedData)) {
                        document.getElementById('refresh-container').classList.add("active");
                    } else {
                        checkIfNewDataIsPresent();
                    }
                }
            }
        }).catch((error) => { document.getElementById('refresh-container').classList.add("active"); });
    }, 3600000);
}
document.addEventListener('feedLoaded', checkIfNewDataIsPresent);

function removeFeeds() {
	document.querySelector('.feed-container').innerHTML = ' '; // Leave Blank Space so 'firstChild' is defined
}

if (document.getElementById('refresh-container') != null) {
	document.getElementById('refresh-container').addEventListener('click', function () {
		window.scrollTo(0, 0);
		scrollPos = 0;
		wmdPageLink('fy-pg_reload', this);
		document.getElementById('refresh-container').classList.remove("active");
		removeFeeds();
		if (document.querySelectorAll('.feed-container .pers-feed-item').length === 0) {
			for (let i = 0; i <= 10; i++) {
				document.querySelector('.feed-container').appendChild(_u.strToDom(_feed.feedLoader()));
			}
		}
		window.location.reload(); // refresh whole page due to mednet cookie expiration
	});
}
/* / FEED REFRESH LOGIC */


/* 'FEEDANDTOPLOADED' EVENT */
let feedDone = false;
let topArticleLoaded = false;

function topArticleAndFeedsEvent(e) {
	if (typeof e == 'undefined') { // If the event is undefined, it's called by timeout fallback, so proceed fire event and clear listeners
		document.removeEventListener('topArticleLoaded', topArticleAndFeedsEvent);
		document.removeEventListener('feedLoaded', topArticleAndFeedsEvent);
		_v.feedAndTopLoaded = true;
		document.dispatchEvent(new CustomEvent('feedAndTopLoaded'));		
	} else {
		if (e.type == 'feedLoaded') {
			feedDone = true;
		}
		else if (e.type == 'topArticleLoaded') {
			topArticleLoaded = true;
		}
		if (topArticleLoaded && feedDone) {
			clearTimeout(loadEventTimeout);
			document.removeEventListener('topArticleLoaded', topArticleAndFeedsEvent);
			document.removeEventListener('feedLoaded', topArticleAndFeedsEvent);
			_v.feedAndTopLoaded = true;
			document.dispatchEvent(new CustomEvent('feedAndTopLoaded'));
		}	
	}
}
document.addEventListener('topArticleLoaded', topArticleAndFeedsEvent);
document.addEventListener('feedLoaded', topArticleAndFeedsEvent);
let loadEventTimeout = setTimeout(topArticleAndFeedsEvent, 5000);
/* / 'FEEDANDTOPLOADED' EVENT */